var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHeaderimages = function SvgHeaderimages(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 42.438L16.914 32.434L26.826 44H6V42.438V42.438Z",
    fill: "#FFE0E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.46 44L22.976 36.436L32.97 26.442L44 38.388V44H29.46V44Z",
    fill: "#FFE0E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47 10.0001H34.46L25.7432 0.313476C25.5479 0.113006 25.2799 -6.10352e-05 25 -6.10352e-05C24.7201 -6.10352e-05 24.4521 0.113006 24.2568 0.313476L15.54 10.0001H3C1.34315 10.0001 0 11.3432 0 13.0001V47.0001C0 48.6569 1.34315 50.0001 3 50.0001H47C48.6569 50.0001 50 48.6569 50 47.0001V13.0001C50 11.3432 48.6569 10.0001 47 10.0001ZM25 2.47861L31.7686 10H18.2314L25 2.47861ZM47 48C47.5523 48 48 47.5523 48 47V13C48 12.4477 47.5523 12 47 12H3C2.44772 12 2 12.4477 2 13V47C2 47.5523 2.44772 48 3 48H47Z",
    fill: "#FC628F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 14H45C45.5523 14 46 14.4477 46 15V45C46 45.5523 45.5523 46 45 46H5C4.44772 46 4 45.5523 4 45V15C4 14.4477 4.44772 14 5 14ZM44 35.4434V16H6V39.7266L16.3242 30.2626C16.5237 30.0791 16.7892 29.9847 17.0598 30.0009C17.3303 30.0171 17.5826 30.1426 17.7588 30.3486L21.672 34.914L32.2934 24.293C32.4896 24.1066 32.7494 24.0018 33.02 24C33.2922 24.0054 33.5503 24.1219 33.7344 24.3224L44 35.4434ZM6 42.4384L16.914 32.4344L26.8266 44H6V42.4384ZM22.9778 36.4376L29.46 44H44V38.3886L32.9716 26.4434L22.9778 36.4376Z",
    fill: "#FC628F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 22C16 24.2091 14.2091 26 12 26C9.79086 26 8 24.2091 8 22C8 19.7909 9.79086 18 12 18C14.2091 18 16 19.7909 16 22ZM14 22C14 20.8954 13.1046 20 12 20C10.896 20.0013 10.0013 20.896 10 22C10 23.1046 10.8954 24 12 24C13.1046 24 14 23.1046 14 22Z",
    fill: "#FC628F"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHeaderimages);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/headerimages.af6db6e3c9cf386a0010f4857dea2bc4.svg";